import React from 'react';
import { createUseStyles } from 'react-jss';
import TetherComponent from 'react-tether';

const styles = createUseStyles({
    dialogContainer: {
        maxWidth: '250px',
        maxHeight: '750px',
        overflow: 'auto',
        background: 'white',
        borderRadius: '6px',
        padding: '13px',
        boxShadow: '0 2px 8px 0 rgb(84 94 102 / 12%)',
        textAlign: 'start'
    }
});

interface FieldDetailDialogProp {
    isOpen: Boolean;
    fieldValue: String;
    TargetRef: any;
}
const FieldDetailDialog = ({ TargetRef, isOpen, fieldValue }: FieldDetailDialogProp) => {
    const classes = styles();
    return (
        <TetherComponent
            attachment="top center"
            targetAttachment="top center"
            constraints={[{ to: 'window', attachment: 'together', pin: true }]}
            renderTarget={(ref) => TargetRef(ref)}
            renderElement={(ref) =>
                isOpen && (
                    <div
                        ref={ref}
                        dir="auto"
                        className={classes.dialogContainer}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        {fieldValue}
                    </div>
                )
            }
        />
    );
};
export default FieldDetailDialog;
